var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vacancy-stage",on:{"click":_vm.stageClick}},[_c('div',{staticClass:"vacancy-stage__left"},[(_vm.data.icon)?_c('Picture',{class:[
        'vacancy-stage__picture',
        !_vm.activeStage ? 'vacancy-stage__picture--disabled' : ''
      ],attrs:{"url":_vm.data.icon ? _vm.data.icon : '',"alt":"icon","height":"24","width":"24"}}):_vm._e(),_c('p',{class:[
        'vacancy-stage__name',
        !_vm.activeStage ? 'vacancy-stage--disabled' : ''
      ]},[_vm._v(" "+_vm._s(_vm.data.name)+" ")])],1),_c('p',{staticClass:"vacancy-stage__count"},[_vm._v(_vm._s(_vm.data.counter))])])
}
var staticRenderFns = []

export { render, staticRenderFns }